define('casino/providers/WMS',['jquery'], function($) {
    'use strict';

    function WMS(casino, gameFunctions) {
        if (!(this instanceof WMS)) {
            throw new TypeError('WMS constructor cannot be called as a function.');
        }

        this.casino = casino;
        this.gameFunctions = gameFunctions;
    }

    function freeMode(wms, game, options) {
        wms.gameFunctions.hideHelpButton();
        var provider = wms.casino.getProvider(game);
        var src = provider.url;

        var splitIdAndCode = game.code.split('_');
        if (splitIdAndCode[0] !== 'WMS') {
            throw new Error('Illegal game code not starting with WMS: ' + game.code);
        }

        var $gameHolder = options.gameHolder;

        var $game = $gameHolder.find('.game');
        $game.empty();

		if(game.html5Format === 1){

			src = provider.url_html5;
			src += $.param({
				partnercode: provider.partnerId,
				game: game.publishCode,
				locale: provider.locale,
				realmoney: 'false'
			});
		}
		else {
			src += $.param({
				partnerCode: provider.partnerId,
				gameCode: game.publishCode,
				locale: provider.locale,
				realMoney: 'false'
			});
		}



        wms.gameFunctions.switchToFreeMode(game, {
            gameHolder: options.gameHolder,
            type: 'iframe',
            src: src
        });
    }

    function realMode(wms, game, options, data) {
        wms.gameFunctions.hideHelpButton();
        var provider = wms.casino.getProvider(game);
        var src = provider.url;

        var splitIdAndCode = game.code.split('_');
        if (splitIdAndCode[0] !== 'WMS') {
            throw new Error('Illegal game code not starting with WMS: ' + game.code);
        }

        var $gameHolder = options.gameHolder;

        var $game = $gameHolder.find('.game');
        $game.empty();

		if(game.html5Format === 1) {

			src = provider.url_html5;
			src += $.param({
				partnercode: provider.partnerId,
				game: game.publishCode,
				partneraccountid: data.playerReference,
				partnerticket: data.sessionId,
				locale: provider.locale,
				realmoney: 'true',
				context: 'default'
			});
		}
		else {
			src += $.param({
				partnerCode: provider.partnerId,
				gameCode: game.publishCode,
				accountId: data.playerReference,
				ticket: data.sessionId,
				locale: provider.locale,
				realMoney: 'true'
			});
		}
        wms.gameFunctions.switchToRealMode(game, {
            gameHolder: options.gameHolder,
            type: 'iframe',
            src: src
        });
        wms.gameFunctions.verifyCurrency(data.currency);
    }

    WMS.prototype = {
        constructor: WMS,
        freeMode: function(game, options) { freeMode(this, game, options); },
        realMode: function(game, options, data) { realMode(this, game, options, data); }
    };

    return WMS;
});

